import keyMirror from 'keymirror'

export default keyMirror({
  GET_PERS_IOT_MESSAGE_REQUEST: null,
  GET_PERS_IOT_MESSAGE_SUCCESS: null,
  GET_PERS_IOT_MESSAGE_FAILED: null,

  UPDATE_FILTER_IOT_MESSAGE_SUCCESS: null
})
